import React from 'react';

function Ranking(props) {
  return (
    <div className="ranking">
      <div className="ranking-title">
        <h3>Ranking</h3>
      </div>
      <div className="ranking-board">
        <table className="table table-hover">
          <tbody>
            { 
              props.leaderboard.map(item => {
                return (
                  <tr key={item._id} className={item._id === props.player ? 'active' : ''}>
                    <td>{item.position}</td>
                    <td>{item.name}</td>
                    <td>{`${item.points} puntos`}</td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Ranking;